// extracted by mini-css-extract-plugin
module.exports = {"video":"external-video_video__FbQt9"};